// @ts-nocheck
import {
  secondaryMain,
  grayDark,
  yellowMain,
  white,
} from 'crehana-ui/styles/colors';

import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import { AppProps } from './App';

import {
  InitialState,
  Membership,
  MembershipBenefits,
  MembershipCategoryFaqs,
  MembershipCategoryProffessors,
  MembershipCategorySkills,
  MembershipConfigurationData,
  RawMembershipsEdge,
  WithFormatMembership,
} from './types';

const getTitleI18nKey = (tag: string) => {
  switch (tag) {
    case 'PREMIUM':
      return 'INDIVIDUAL';
    case 'FAMILIAR':
      return 'FAMILY';
    case 'PREMIUM_DUO':
      return 'DUO';
    default:
      return '';
  }
};

const getMembershipTag = (identifier: string) => {
  const PREMIUM = '1';
  const PREMIUM_DUO = '2';
  const PREMIUM_FAMILIAR = '3';

  if (identifier === PREMIUM) return 'PREMIUM';

  if (identifier === PREMIUM_DUO) return 'PREMIUM_DUO';

  if (identifier === PREMIUM_FAMILIAR) return 'FAMILIAR';

  return '';
};

const getBenefits = (membership: Membership): Array<MembershipBenefits> => {
  return membership.benefitsV2.map(el => ({
    id: el.originalId,
    text: el.text,
    isAvailable: true,
  }));
};

const getInitialState: GetInitialStateInner<AppProps> = (
  _,
  __,
  { crehanaApp },
) => {
  const {
    membershipsPlanOrderKey,
    membershipsPlanTagKey,
    categoryLanding,
    membershipTypes: memberships,
  } = crehanaApp;

  const membershipConfigurationData: Array<MembershipConfigurationData> = (
    membershipsPlanOrderKey || '1,2*,3'
  )
    .replace(/\s/g, '')
    .split(',')
    .map((el: string, index: number) => {
      let cleanedValue = '';
      const regExResult = el.match(/\d+/);

      if (regExResult && regExResult?.length) {
        cleanedValue = regExResult[0] || '';
      }

      return {
        membershipTag: getMembershipTag(cleanedValue),
        order: index + 1,
        isHighlighted: el.length > 1,
      };
    });

  const formatMemberships = (
    rawMemberships: Membership[],
  ): Array<WithFormatMembership> => {
    const _memberships = rawMemberships
      .map((membership: Membership) => {
        const isHighlighted = membershipConfigurationData.find(
          el => el.membershipTag === membership.tag,
        )?.isHighlighted;

        return {
          ...membership,
          ribbonText: '',
          promoMessage: isHighlighted
            ? membershipsPlanTagKey || 'MÁS COMPRADO'
            : '',
          titleI18nKey: getTitleI18nKey(membership.tag),
          benefits: getBenefits(membership),
          isHighlighted: Boolean(isHighlighted),
          order:
            membershipConfigurationData.find(
              el => el.membershipTag === membership.tag,
            )?.order || 0,
        };
      })
      .sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      });

    return _memberships;
  };

  const initialState: InitialState = {
    categoryId: categoryLanding.originalId,
    heroSection: {
      title: categoryLanding.heroTitle,
      subtitle: categoryLanding.heroSubtitle,
      buttonLabel: categoryLanding.heroButtonLabel,
      backgroundImage: {
        webp: `${categoryLanding.backgroundImage}?fm=webp`,
        jpg: categoryLanding.backgroundImage,
      },
    },
    featuresSection: {
      imageUrl: categoryLanding.skillImage,
      features: categoryLanding.skills.map(
        (el: MembershipCategorySkills, index: number) => ({
          id: index,
          description: el.subtitle,
          ...el,
        }),
      ),
    },
    mentorsSection: {
      title: categoryLanding.teacherTitle,
      subtitle: categoryLanding.teacherSubtitle,
      mentors: categoryLanding.professors.map(
        (el: MembershipCategoryProffessors, index: number) => ({
          id: index,
          ...el,
          avatarUrl: el.professorImage,
          companyLogoUrl: el.companyLogo,
        }),
      ),
    },
    membershipsSection: {
      title: categoryLanding.membershipTitle,
      membershipCardColors: {
        accent: yellowMain,
        title: secondaryMain,
        text: white,
        tag: yellowMain,
        legals: grayDark,
        listIcon: white,
      },
      memberships: formatMemberships(
        memberships.edges.map((el: RawMembershipsEdge) => el.node),
      ),
    },
    faqSection: {
      title: categoryLanding.faqTitle,
      questions: categoryLanding.faqs.map(
        (el: MembershipCategoryFaqs, index: number) => ({
          id: index,
          ...el,
        }),
      ),
    },
  };

  return initialState;
};

export default getInitialState;
